import { ButtonSize, ButtonVariant } from "@galaxy-io/dls/buttons/Button";
import Alert, { AlertVariant } from "@galaxy-io/dls/feedback/Alert";
import Text, { TextSize } from "@galaxy-io/dls/text/Text";
import { useFormStatus } from "react-dom";
import { Button } from "@/components/ui/button";
import { AuthLayout } from "./auth-layout";

export function AuthSubmit({ label = "Sign in" }: { label?: string }) {
  const { pending } = useFormStatus();
  return (
    <Button
      type="submit"
      fillWidth
      size={ButtonSize.MEDIUM}
      variant={ButtonVariant.PRIMARY}
      label={pending ? "Continuing…" : label}
      isLoading={pending}
    />
  );
}
export function LoginView({
  configured,
  error,
  signIn,
}: {
  configured: boolean;
  error?: string;
  signIn: () => Promise<void>;
}) {
  return (
    <AuthLayout>
      <Text size={TextSize.HEADING_MD} as="h1">
        Sign in to Galaxy
      </Text>
      {configured ? (
        <form action={signIn}>
          <AuthSubmit />
        </form>
      ) : (
        <Text>Sign-in is not configured. Contact your workspace administrator.</Text>
      )}
      {error && (
        <Alert variant={AlertVariant.ERROR}>
          {error === "AccessDenied"
            ? "You need workspace access to sign in. If you were invited, open your invitation link and use the invited email address."
            : "Sign-in could not be completed. Try again, or reopen your invitation link."}
        </Alert>
      )}
    </AuthLayout>
  );
}
